import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/academy-frontend/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/academy-frontend/src/components/common/image/CommonImage.js");
